import React from 'react';
import { FormattedList, FormattedMessage } from 'react-intl';

import { STATUSES } from 'constants/InterventionConstants';
import { ChannelEnum } from 'modules/global/typing/enums/steps.enum';
import { createDictionary } from 'utils/ObjectUtils';

export const EMAIL_SUBJECT_MAX_LENGTH = 100;

export const MULTI_SEGMENT_SIZE = 153;

export const MINIMAL_SEGMENT_SIZE = 160;

export const DELIVERY_METHOD = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  EMAIL_AND_SMS: 'EMAIL_AND_SMS',
  EMAIL_OR_SMS: 'EMAIL_OR_SMS',
};

// Define the selected method
export const DELIVERY_OPTION = {
  [DELIVERY_METHOD.EMAIL]: (email, sms) => email?.enabled && !sms?.enabled,
  [DELIVERY_METHOD.SMS]: (email, sms) => sms?.enabled && !email?.enabled,
  [DELIVERY_METHOD.EMAIL_AND_SMS]: (email, sms) => sms?.enabled && email?.enabled && sms.priority === email.priority,
  [DELIVERY_METHOD.EMAIL_OR_SMS]: (email, sms) => sms?.enabled && email?.enabled && sms.priority !== email.priority,
};

const PRIORITIES = {
  EMAIL_FIRST: 'EMAIL_FIRST',
  SMS_FIRST: 'SMS_FIRST',
};

export const DELIVERY_PRIORITY = {
  [PRIORITIES.EMAIL_FIRST]: ({ email = {} }) => email?.priority,
  [PRIORITIES.SMS_FIRST]: ({ sms = {} }) => sms?.priority,
};

export const SECTION_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};

export const SECTION_STATUS_ICON = createDictionary(
  {
    [SECTION_STATUS.ERROR]: 'fb-icon--issue',
  },
  'fb-icon--checkmark-circle-1'
);

export const DELIVERY_METHOD_CHANNELS = {
  [DELIVERY_METHOD.EMAIL]: [ChannelEnum.EMAIL],
  [DELIVERY_METHOD.SMS]: [ChannelEnum.SMS],
  [DELIVERY_METHOD.EMAIL_AND_SMS]: [ChannelEnum.EMAIL, ChannelEnum.SMS],
  [DELIVERY_METHOD.EMAIL_OR_SMS]: [ChannelEnum.EMAIL, ChannelEnum.SMS],
};

export const DELIVERY_METHOD_LABEL = {
  [DELIVERY_METHOD.EMAIL]: (
    <FormattedMessage id="page.fiche.acceptManuallyModal.reason.Email" defaultMessage="E-mail" />
  ),
  [DELIVERY_METHOD.SMS]: <FormattedMessage id="page.fiche.acceptManuallyModal.reason.sms" defaultMessage="SMS" />,
  [DELIVERY_METHOD.EMAIL_AND_SMS]: (
    <FormattedList
      type="conjunction"
      value={[
        <FormattedMessage id="page.fiche.acceptManuallyModal.reason.Email" defaultMessage="E-mail" />,
        <FormattedMessage id="page.fiche.acceptManuallyModal.reason.sms" defaultMessage="SMS" />,
      ]}
    />
  ),
  [DELIVERY_METHOD.EMAIL_OR_SMS]: (
    <FormattedList
      type="disjunction"
      value={[
        <FormattedMessage id="page.fiche.acceptManuallyModal.reason.Email" defaultMessage="E-mail" />,
        <FormattedMessage id="page.fiche.acceptManuallyModal.reason.sms" defaultMessage="SMS" />,
      ]}
    />
  ),
};

export const DELIVERY_PRIORITIES_LABEL = {
  [PRIORITIES.EMAIL_FIRST]: (
    <FormattedMessage id="page.campaigns.details.priorities.EMAIL_FIRST" defaultMessage="E-mail first" />
  ),
  [PRIORITIES.SMS_FIRST]: (
    <FormattedMessage id="page.campaigns.details.priorities.SMS_FIRST" defaultMessage="SMS first" />
  ),
};

export const PRIORITY_LABELS = {
  email: DELIVERY_PRIORITIES_LABEL[PRIORITIES.EMAIL_FIRST],
  sms: DELIVERY_PRIORITIES_LABEL[PRIORITIES.SMS_FIRST],
};

export const DELIVERY_PRIORITIES_DATASOURCE = [
  {
    value: 'sms',
    label: <FormattedMessage id="page.fiche.acceptManuallyModal.reason.sms" defaultMessage="SMS" />,
  },
  {
    value: 'email',
    label: <FormattedMessage id="page.fiche.acceptManuallyModal.reason.Email" defaultMessage="E-mail" />,
  },
];

export const CAMPAIGN_FILE_STATUS = {
  READ: 'READ',
  PENDING: 'PENDING',
  ANSWERED: 'ANSWERED',
};

export const CAMPAIGN_FILES_FILTERED_STATUSES = [CAMPAIGN_FILE_STATUS.PENDING, CAMPAIGN_FILE_STATUS.READ, CAMPAIGN_FILE_STATUS.ANSWERED];

export const LINKED_INTERVENTIONS_STATUSES = [STATUSES.TO_BE_SENT, STATUSES.SENT, STATUSES.READ, STATUSES.ANSWERED, STATUSES.CLOSED];
